import { render, staticRenderFns } from "./CategoriesGrid.vue?vue&type=template&id=7f79b462&"
import script from "./CategoriesGrid.vue?vue&type=script&lang=js&"
export * from "./CategoriesGrid.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesGrid.vue?vue&type=style&index=0&id=7f79b462&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports